import './Login.css';
import SERVER_URL from '../../env.js';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useAuthorization } from '../../Utils/AuthUtils.js';

function Login() {
    const navigate = useNavigate()
    const [message, setMessage] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const { authInfo } = useAuthorization()
    useEffect(() => {
        if (authInfo?.user) {
            navigate('/dashboard')
        }
    }, [authInfo, navigate]);

    const handleEmail = (e) => {
        setEmail(e.target.value);
    }
    const handlePassword = (e) => {
        setPassword(e.target.value);
    }
    const handleSubmit = () => {
        fetch(SERVER_URL + '/auth/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: email,
                password: password,
            }),
        })
            .then((res) => res.json())
            .then((data) => handleResult(data));
    }

    const handleResult = (data) => {
        if (!data.error) {
            Cookies.set('accessToken', data.accessToken, { expires: 30 })
            Cookies.set('refreshToken', data.refreshToken, { expires: 30 })
            navigate('/dashboard')
        } else {
            setMessage(data.error);
        }
    };

    return (
        <div className="Login">
            <div className="Login-box">
                {message && <div className="Login-error-message">{message}</div>}
                <div className="Login-input-container">
                    <input className="Login-input" type="text" placeholder="Email" onChange={handleEmail} />
                    <input className="Login-input" type="password" placeholder="Password" onChange={handlePassword} />
                </div>
                <button className="Login-button" onClick={handleSubmit}>Login</button>

            </div>

        </div>
    );
}

export default Login;
